import { DEBUG, PATH } from '../constants';


const base = PATH;
const debug = DEBUG;

export async function sendGameData(payload) {
    try {
      const response = await fetch( base + 'grid/send', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${payload.authToken}` // si nécessaire
        },
        body: JSON.stringify(payload)
      });
  
      if (!response.ok) {
        throw new Error(`Erreur API : ${response.status}`);
      }
  
      const data = await response.json();
      return data; // ou simplement "return true" si pas besoin de la réponse
    } catch (error) {
      console.error('Erreur lors de l’envoi des données du jeu :', error);
      throw error;
    }
  }